<template>
  <b-card>
    <b-modal
      id="rider-health-modal"
      centered
      title="User Health"
      hide-footer
      @shown="riderHealthModalShown"
    >
      <b-spinner
        v-if="fetchingHealth"
        variant="primary"
      />
      <div v-else>
        <div v-if="riderHealthData && Object.keys(riderHealthData).length">
          <b-list-group>
            <b-list-group-item
              v-for="(value, key) in riderHealthData"
              :key="key"
              class="d-flex justify-content-between align-items-center"
            >
              <strong>{{ key }}</strong>
              <span>{{ value }}</span>
            </b-list-group-item>
          </b-list-group>
        </div>
        <div v-else>
          <p>No health data available.</p>
        </div>
      </div>
    </b-modal>
    <b-card-title class="d-flex justify-content-between align-items-center">
      <b-button
        class="btn-icon rounded-circle"
        variant="flat-primary"
        @click="
          $router.push({
            path: `/users/${trip.user_details.id}?externalId=${trip.user_details.external_id}`,
          })
        "
      >
        <feather-icon icon="UserIcon" />
      </b-button>
      <div class="d-flex align-items-center">
        <h4 class="text-center mr-1 mb-0">
          User
        </h4>
        <b-button
          variant="outline-primary"
          size="sm"
          @click="$bvModal.show('rider-health-modal')"
        >
          User Health
        </b-button>
      </div>
      <b-button
        class="btn-icon rounded-circle"
        variant="flat-primary"
        @click="
          $router.push({
            path: `/users/${trip.user_details.id}?externalId=${trip.user_details.external_id}`,
            query: { 'active-tab': 'wallet' },
          })
        "
      >
        <feather-icon icon="BriefcaseIcon" />
      </b-button>
    </b-card-title>
    <template v-if="performanceData">
      <b-row>
        <b-col
          md="6"
          class="d-flex align-items-center"
        >
          <div class="d-flex align-items-center">
            <span class="font-weight-bold mr-1">Joined Days:</span>
            {{ performanceData.joined_days }}
          </div>
        </b-col>
        <b-col
          md="6"
          class="d-flex align-items-center"
        >
          <div class="d-flex align-items-center">
            <span class="font-weight-bold mr-1">Completed Trips:</span>
            {{ performanceData.no_all_completed_trips }}
          </div>
        </b-col>
        <b-col
          md="12"
          class="d-flex align-items-center"
        >
          <div class="d-flex align-items-center">
            <span class="font-weight-bold mr-1">Frequency:</span>
            {{ performanceData.frequency }}
          </div>
        </b-col>
      </b-row>
    </template>
    <hr>
    <b-row
      v-if="trip"
      class="pt-2"
    >
      <b-col
        v-for="(item, idx) in pickFrom"
        :key="idx"
        md="12"
        class="mb-1"
      >
        <span class="font-weight-bold">{{ item.label }}: </span>
        {{ item.key(trip.user_details) ? item.key(trip.user_details) : "_" }}
      </b-col>
    </b-row>
    <Visa
      v-if="
        tripDetails.state == 'COMPLETED' ||
          tripDetails.state == 'ACCEPTED' ||
          tripDetails.state == 'IN_PROGRESS' ||
          tripDetails.state == 'ARRIVED' ||
          tripDetails.state == 'CANCELED'
      "
    />
  </b-card>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BRow,
  BCol,
  BButton,
  BListGroup,
  BListGroupItem,
  BSpinner,
} from 'bootstrap-vue'
import { computed, inject, ref } from '@vue/composition-api'
import Visa from './Visa.vue'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BSpinner,
    BListGroup,
    BListGroupItem,
    BCard,
    BCardTitle,
    BRow,
    BCol,
    BButton,
    Visa,
  },
  setup(_, ctx) {
    const tripDetails = computed(
      () => ctx.root.$store.getters['trips/getTripDetails'],
    )
    const pickFrom = [
      {
        key: el => `${el?.first_name} ${el?.last_name}`,
        label: 'Name',
      },
      {
        key: el => el?.phone_number,
        label: 'Phone Number',
      },
      {
        key: el => el?.email,
        label: 'Email',
      },
      {
        key: el => `${el?.rating || '_'}`,
        label: 'Rating',
      },
    ]
    const trip = inject('trip')

    const performanceData = ref()
    const fetchDriverHealth = async () => {
      const res = await axiosIns.get('/trips/performance/segmentation', {
        params: {
          external_id: trip.value.user_details.external_id,
          type: 'user',
        },
      })
      performanceData.value = res.data.data
    }
    if (Object.keys(trip.value.user_details).length) {
      fetchDriverHealth()
    }

    const riderHealthData = ref({})
    const fetchingHealth = ref(false)
    const fetchRiderHealth = async () => {
      fetchingHealth.value = true
      try {
        const res = await axiosIns.get('/users/dashboard-health', {
          params: {
            userId: trip.value.user_details.external_id,
            dashboardType: 'Rider-Health',
          },
        })
        const { data } = res.data
        riderHealthData.value = data
      } finally {
        fetchingHealth.value = false
      }
    }

    const riderHealthModalShown = () => {
      fetchRiderHealth()
    }

    return {
      riderHealthData,
      performanceData,
      riderHealthModalShown,
      tripDetails,
      trip,
      fetchingHealth,
      pickFrom,
    }
  },
}
</script>

<style scoped></style>
